import { setNetwork } from "@utils/index";

export const NETWORK = {
    OPDEV: 'opdev',
    SB: 'sb',
    RC: 'rc',
    STAGE: 'stage',
    LIVE: 'live'
};

export const CUR_NETWORK = setNetwork();